
import CallToAction from '~/components/Modules/Common/CallToAction'
import RichText from '~/components/Modules/Common/RichText'

export default {
  components: { CallToAction, RichText },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
}
